/* jshint esversion: 6 */
/**
 * @copyright Copyright (c) 2020 René Gieling <github@dartcafe.de>
 *
 * @author René Gieling <github@dartcafe.de>
 *
 * @license  AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 *
 */
export const dateUnits = {
	data() {
		return {
			dateUnits: [
				{ name: t('polls', 'Minute'), value: 'minute' },
				{ name: t('polls', 'Hour'), value: 'hour' },
				{ name: t('polls', 'Day'), value: 'day' },
				{ name: t('polls', 'Week'), value: 'week' },
				{ name: t('polls', 'Month'), value: 'month' },
				{ name: t('polls', 'Year'), value: 'year' },
			],
		}
	},
}
